/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Коллекция для заявок в совместной закупке.
   */
  app.JPOrders = app.ItemPageableCollection.extend({
    model: app.Model,
    url: app.entryScriptName + '/api/v3/order/',
    isScroll: false,
    loadItems: true,
    loadFilters: false,
    requestFilters: false,
    filterLoadParams: [],
    itemsNotLoadParams: [],
    sortTypes: ['-created_at', '-subtotal'],
    state: {
      firstPage: 1,
      pageSize: 20,
      order: 0
    },
    jp_purchase_id: 0,
    setQueryParams: function () {
      var that = this;
      this.queryParams = {
        totalRecords: function () {
          return that.totalPages;
        },
        currentPage: 'page',
        pageSize: 'per-page',
        sort: function () {
          return that.sort;
        },
        totalPages: 'page_count',
        jp_purchase_id: function () {
          return that.jp_purchase_id;
        },
        jp_order_status_id: '1,7,8',
        is_jp_request_only: 1,
        expand: 'jp_order,qty,items_count,user,settlement'
      };
    },
    /**
     * Устанавливает дефолтные свойства коллекции
     */
    setDefaultProperties: function () {
      this.sort = this.defaults.sort;
      this.jp_purchase_id = this.defaults.jp_purchase_id;
      this.mode = this.defaults.mode;
    }
  });
})();



}.call(window));